import { Component, OnInit } from '@angular/core';
import { DFieldBaseComponent } from '../d-field-base.component';
import { UntypedFormBuilder } from '@angular/forms';

@Component({
  selector: 'app-d-field-input',
  templateUrl: './d-field-input.component.html',
  styleUrls: ['./d-field-input.component.scss']
})
export class DFieldInputComponent extends DFieldBaseComponent {
  constructor(protected fb: UntypedFormBuilder) {
    super(fb);
  }

}
